export const TranscriptionPanel = function (session_nid) {
  const template = `
<div x-show="transcriptions.length === 0" class="transcriptions-empty">no transcriptions</div>
<div x-show="transcriptions.length > 0" class="transcription-list">
<template x-for="item in transcriptions" :key="item.sequence_number">
  <div class="transcription">
    <div class="transcription-info">
      <span class="user-name" x-html="item.user_name_link"></span>
      <span class="time" x-text="item.time"></span>
    </div>
    <div class="transcription-text" x-text="item.transcription"></div>
  </div>
</template>
</div>
<div class="scroll-button"><i class="fa-regular fa-circle-chevron-down" aria-hidden="true"></i></div>
  `;
  return {
    sid: session_nid,
    partialTranscriptions: [],
    fullTranscriptions: [],

    get transcriptions() {
      return [...this.fullTranscriptions, ...this.partialTranscriptions].sort((a, b) => a.timestamp - b.timestamp);
    },

    async init() {
      this.$el.innerHTML = template;
      document.addEventListener('participants-transcription-updated', async (event) => {
        const item = structuredClone(event.detail);
        console.log('participants-transcription-updated', item);
        if (item?.sid === this.sid) {
          const pid = item?.participant ?? '';
          let localParticipant = Toolbox.snVideoCall.activeRoom?.localParticipant;
          let id = '';
          if (pid === localParticipant?.sid) {
            id = localParticipant?.identity ?? '';
          }
          if (!id) {
            id = Toolbox.snVideoCall.activeRoom?.participants?.get(pid)?.identity ?? '';
          }
          if (!id) {
            return;
          }

          const info = await Toolbox.twilio.getUserInfoAsync(id);
          if (info) {
            item.sequence_number = `a${id}-${item.sequence_number}`;
            item.user_name = info.fullname;
            item.user_logo = info?.user_logo ?? '';
            item.user_name_link = info.user_name_link ?? '';
            item.time = Toolbox.util.get_stamp_format(new Date(item.timestamp), 'STAMP_TIME');

            if (item.partial_results) {
              if (item.stability >= 0.9) {
                const existingItem = this.partialTranscriptions.find(i => i.participant === pid);
                if (existingItem) {
                  existingItem.transcription = item.transcription;
                } else {
                  this.partialTranscriptions.push(item);
                }
              }
            } else {
              this.fullTranscriptions.push(item);
              this.partialTranscriptions = this.partialTranscriptions.filter(i => i.participant !== pid);
            }
          }
        }
      });

      const handleScroll = (event) => {
        const {scrollTop, scrollHeight, clientHeight} = scrollPanel;
        const distanceToBottom = scrollHeight - scrollTop - clientHeight;

        if (distanceToBottom > 50) {
          scrollButton.style.display = 'block';
        } else {
          scrollButton.style.display = 'none';
        }
      };

      this.$watch('transcriptions', (newValue, oldValue) => {
        if (newValue.length > 0) {
          handleScroll();
          scrollPanel.scrollTop = scrollPanel.scrollHeight;
        }
      });

      const scrollPanel = this.$el.querySelector('.transcription-list');
      const scrollButton = this.$el.querySelector('.scroll-button');

      scrollButton.addEventListener('click', (event) => {
        scrollPanel.scrollTop = scrollPanel.scrollHeight;
      });

      scrollPanel.addEventListener('scroll', handleScroll);
    }
  }
}
